

































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/api/cycles';
import { FileLoadHistory } from '@/api/fileloadhistory';
import { ImportSummaryResource } from '@/api/importsummary/ImportSummaryResource';

@Component({
  computed: mapState(['fiId']),
})
export default class ImportSummaryTable extends Vue {
    fiId!: string;

    @Prop({ default: {} as Cycle }) selectedCycle!: Cycle;

    headers: DataTableHeader[] = [
      { text: 'Processing Date', value: 'processingDate' },
      { text: '# Accounts from Balances', value: 'accountCount' },
      { text: '# Customers from CIF', value: 'accountHolderCount' },
      { text: '# Trx Loaded', value: 'transactionLoadedCount' },
      { text: '# Trx in DB for ProcessingDate', value: 'transactionInDbForProcessingDateCount' },
      { text: '# Relationships', value: 'accountToAccountHolderCount' },
      { text: '# Iblogins', value: 'ibLoginCount' },
      { text: 'Job Execution Id', value: 'jobExecutionId' },
    ];

    loading: boolean = false;

    totalItems: number = 0;

    importSummaries: FileLoadHistory[] = [];

    @Inject('ImportSummaryResource')
    importSummaryResource!: ImportSummaryResource;

    @Watch('fiId')
    onFiChange() {
      this.importSummaries = [];
      this.loading = true;
    }

    @Watch('selectedCycle')
    onCycleChange() {
      this.importSummaries = [];
      this.loading = true;
      this.loadImportSummaries();
    }

    showErrorMessage(error: string) {
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }

    mounted() {
      this.loading = true;
      this.loadImportSummaries();
    }

    loadImportSummaries() {
      this.importSummaryResource.getImportSummariesForCycle(this.fiId, this.selectedCycle.qualificationStartDate.toString(),
        this.selectedCycle.qualificationEndDate.toString()).then((importSummaries: FileLoadHistory[]) => {
        this.importSummaries = importSummaries;
        this.totalItems = importSummaries.length;
        this.loading = false;
      });
    }

    handleError(error: any) {
      if (error.response.status !== 401) {
        if (error.response.status === 504) {
          this.showErrorMessage('The request timed out.');
        } else {
          this.showErrorMessage('An unexpected error occurred while attempting to perform the request.');
        }
      }
    }

    getClass = (importSummary: FileLoadHistory): string => {
      if (!importSummary.isProcessingDay || importSummary.isHoliday) {
        return 'non-processing-day';
      }
      if (importSummary.transactionLoadedCount > 0 && importSummary.transactionInDbForProcessingDateCount > 0) {
        return 'data-import-ok-class';
      }

      return 'no-import-data-warning-class';
    }
}
